document.addEventListener('DOMContentLoaded', function () {

  // Grid/List view toggle
  const productGridContainer = document.querySelector('.collection_customized .product-grid-container');
  if (productGridContainer) {
    productGridContainer.classList.add('grid-view');
  }

  const gridViewBtn = document.querySelector('.collection_customized .grid-view');
  const listViewBtn = document.querySelector('.collection_customized .list-view');
  const allProductGrids = document.querySelectorAll('.product-grid-container');

  if (gridViewBtn) {
    gridViewBtn.addEventListener('click', function () {
      allProductGrids.forEach(function (el) {
        el.classList.remove('list-view');
        el.classList.add('grid-view');
      });
    });
  }

  if (listViewBtn) {
    listViewBtn.addEventListener('click', function () {
      allProductGrids.forEach(function (el) {
        el.classList.remove('grid-view');
        el.classList.add('list-view');
      });
    });
  }

  // Sliders
  const sections = document.querySelectorAll('.collection-list-slider-section');
  const logo_sections = document.querySelectorAll('.logo-slider-section');

  function initCollectionSlider() {
    sections.forEach(function (section) {
      var el = section.querySelector('.grid.grid-slider');
      if (!el) return;

      imagesLoaded(el, function () {
        var slides = el.children.length;
        var isDesktop = window.innerWidth >= 1024;

        if (el._flkty) {
          el._flkty.destroy();
          el._flkty = null;
        }

        if (isDesktop && slides <= 4) return;

        el._flkty = new Flickity(el, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: true,
          groupCells: false
        });
      });
    });

    logo_sections.forEach(function (logo_section) {
      var el = logo_section.querySelector('.logo-slider');
      if (!el) return;

      imagesLoaded(el, function () {
        var slides = el.children.length;
        var isDesktop = window.innerWidth >= 1024;

        if (el._flkty) {
          el._flkty.destroy();
          el._flkty = null;
        }

        if (isDesktop && slides <= 5) return;

        el._flkty = new Flickity(el, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          groupCells: false
        });
      });
    });
  }

  initCollectionSlider();

  // Uncomment to enable resize handling:
  // window.addEventListener('resize', function () {
  //   clearTimeout(window._sliderResizeTimer);
  //   window._sliderResizeTimer = setTimeout(initCollectionSlider, 200);
  // });

});